import React, { useState } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';

import { useSiteSettings } from '../../context/SiteSettingsContext';
import { BROWSER_API_BASE_URL } from '../../services/apiConfig';
import { resolveUserPermissions, getFirstAllowedRoute } from '../../config/permissions';

import { toast } from 'react-toastify';

import styled from 'styled-components';



export default function Login() {

  const [identifier, setIdentifier] = useState('');

  const [password, setPassword] = useState('');

  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);

  const { login } = useAuth();

  const { settings } = useSiteSettings();

  const navigate = useNavigate();



  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    try {

      const userData = await login(identifier, password);

      toast.success('Login successful!');

      if (userData.role === 'admin') {
        // Land on the first page this admin can actually view (custom roles may not include the dashboard)
        const landing = getFirstAllowedRoute(resolveUserPermissions(userData)) || '/admin';
        navigate(landing);
      } else {
        navigate('/portal');
      }

    } catch (err) {

      console.error('Login error:', err);

      console.error('Response:', err.response);

      console.error('Response data:', err.response?.data);

      if (!err.response) {

        // Network error — server not reachable from browser

        toast.error(`Cannot reach the server at ${BROWSER_API_BASE_URL}. Make sure the backend is running and accessible.`);

      } else {

        const data = err.response.data;

        const msg = data?.detail

          || (data && typeof data === 'object' ? Object.values(data).flat().join(' ') : null)

          || `Login failed (${err.response.status}). Please check your credentials.`;

        toast.error(msg);

      }

    } finally {

      setLoading(false);

    }

  };



  return (

    <StyledWrapper $bgColor={settings?.login_bg_type === 'color' ? (settings?.login_bg_color || '#F8FAFB') : undefined}>

      <div className="container">

        {/* Video background */}

        {settings?.login_bg_type === 'video' && settings?.login_bg_video && (

          <video className="bg-video" autoPlay muted loop playsInline>

            <source src={settings.login_bg_video} />

          </video>

        )}

        {/* Image background */}

        {settings?.login_bg_type === 'image' && settings?.login_bg_image && (

          <div className="bg-image" style={{ backgroundImage: `url(${settings.login_bg_image})` }} />

        )}

        {/* Overlay for image/video backgrounds */}

        {(settings?.login_bg_type === 'image' || settings?.login_bg_type === 'video') && settings?.login_bg_overlay_opacity > 0 && (

          <div className="bg-overlay" style={{ background: settings?.login_bg_overlay_color || '#000000', opacity: settings?.login_bg_overlay_opacity || 0 }} />

        )}

        <div className="card">

          <img src={settings?.header_logo || '/APPSN.jpg'} alt="APPSN" className="logo" />

          <span className="login">Member Sign In</span>

          <p className="subtitle">APPSN - FCT Branch</p>

          <form onSubmit={handleSubmit}>

            <div className="inputBox">

              <input

                type="text"

                required

                value={identifier}

                onChange={(e) => setIdentifier(e.target.value)}

              />

              <span>Email or Shortcode</span>

            </div>

            <div className="inputBox hasToggle">

              <input

                type={showPassword ? 'text' : 'password'}

                required

                value={password}

                onChange={(e) => setPassword(e.target.value)}

              />

              <span>Password</span>

              <button

                type="button"

                className="eyeBtn"

                onClick={() => setShowPassword(s => !s)}

                aria-label={showPassword ? 'Hide password' : 'Show password'}

                tabIndex={-1}

              >

                {showPassword ? (

                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.77 21.77 0 0 1 5.06-6.06"/><path d="M22.54 12.88A21.77 21.77 0 0 0 23 12s-4-8-11-8a10.94 10.94 0 0 0-3.66.64"/><path d="M14.12 14.12a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>

                ) : (

                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>

                )}

              </button>

            </div>

            <button className="enter" type="submit" disabled={loading}>

              {loading ? 'Signing in...' : 'Sign In'}

            </button>

          </form>

          <p className="forgot-link">

            <Link to="/forgot-password">Forgot password?</Link>

          </p>

          <p className="register-link">

            Don't have an account?{' '}

            <Link to="/register">Register here</Link>

          </p>

        </div>

      </div>

    </StyledWrapper>

  );

}



const StyledWrapper = styled.div`

  .container {

    min-height: 70vh;

    display: flex;

    align-items: center;

    justify-content: center;

    padding: 3rem 1rem;

    background: ${props => props.$bgColor || '#F8FAFB'};

    position: relative;

    overflow: hidden;

  }



  .bg-video {

    position: absolute;

    top: 0;

    left: 0;

    width: 100%;

    height: 100%;

    object-fit: cover;

    z-index: 0;

  }



  .bg-image {

    position: absolute;

    top: 0;

    left: 0;

    width: 100%;

    height: 100%;

    background-size: cover;

    background-position: center;

    z-index: 0;

  }



  .bg-overlay {

    position: absolute;

    top: 0;

    left: 0;

    width: 100%;

    height: 100%;

    z-index: 0;

  }



  .logo {

    width: auto;

    height: 80px;

    object-fit: contain;

    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  }



  .login {

    color: #0B5D1E;

    text-transform: uppercase;

    letter-spacing: 2px;

    display: block;

    font-weight: bold;

    font-size: x-large;

    font-family: 'Poppins', sans-serif;

  }



  .subtitle {

    color: #6b7280;

    font-size: 0.875rem;

    margin-top: -15px;

    letter-spacing: 0.5px;

  }



  .card {

    position: relative;

    z-index: 1;

    display: flex;

    justify-content: center;

    align-items: center;

    min-height: 420px;

    width: 380px;

    max-width: 95vw;

    flex-direction: column;

    gap: 25px;

    background: #e3e3e3;

    box-shadow: 16px 16px 32px #c8c8c8,

          -16px -16px 32px #fefefe;

    border-radius: 12px;

    padding: 2.5rem 1.5rem;

  }



  form {

    display: flex;

    flex-direction: column;

    align-items: center;

    gap: 25px;

    width: 100%;

  }



  .inputBox {

    position: relative;

    width: 280px;

    max-width: 100%;

  }



  .inputBox input {

    width: 100%;

    padding: 12px;

    outline: none;

    border: none;

    color: #000;

    font-size: 1em;

    background: transparent;

    border-left: 2px solid #0B5D1E;

    border-bottom: 2px solid #0B5D1E;

    transition: 0.1s;

    border-bottom-left-radius: 8px;

  }



  .inputBox span {

    margin-top: 5px;

    position: absolute;

    left: 0;

    transform: translateY(-4px);

    margin-left: 10px;

    padding: 10px;

    pointer-events: none;

    font-size: 12px;

    color: #374151;

    text-transform: uppercase;

    transition: 0.5s;

    letter-spacing: 3px;

    border-radius: 8px;

  }



  .inputBox input:valid ~ span,

  .inputBox input:focus ~ span {

    transform: translateX(113px) translateY(-15px);

    font-size: 0.8em;

    padding: 5px 10px;

    background: #0B5D1E;

    letter-spacing: 0.2em;

    color: #fff;

    border: 2px;

  }



  .inputBox input:valid,

  .inputBox input:focus {

    border: 2px solid #0B5D1E;

    border-radius: 8px;

  }

  .inputBox.hasToggle input {

    padding-right: 40px;

  }

  .eyeBtn {

    position: absolute;

    right: 8px;

    top: 50%;

    transform: translateY(-50%);

    background: transparent;

    border: none;

    cursor: pointer;

    padding: 4px;

    display: flex;

    align-items: center;

    justify-content: center;

    color: #0B5D1E;

    border-radius: 4px;

  }

  .eyeBtn:hover {

    background: rgba(11, 93, 30, 0.08);

  }

  .eyeBtn:focus {

    outline: 2px solid #0B5D1E;

    outline-offset: 1px;

  }



  .enter {

    height: 48px;

    width: 160px;

    border-radius: 8px;

    border: 2px solid #0B5D1E;

    cursor: pointer;

    background-color: transparent;

    transition: 0.3s;

    text-transform: uppercase;

    font-size: 0.8rem;

    font-weight: 600;

    letter-spacing: 2px;

    color: #0B5D1E;

    margin-top: 5px;

  }



  .enter:hover {

    background-color: #0B5D1E;

    color: white;

  }



  .enter:disabled {

    opacity: 0.5;

    cursor: not-allowed;

  }



  .forgot-link {

    font-size: 0.8125rem;

    margin-top: -15px;

    margin-bottom: -5px;

  }

  .forgot-link a {

    color: #0B5D1E;

    text-decoration: none;

    font-weight: 500;

  }

  .forgot-link a:hover {

    text-decoration: underline;

  }

  .register-link {

    font-size: 0.875rem;

    color: #6b7280;

    margin-top: -5px;

  }



  .register-link a {

    color: #0B5D1E;

    font-weight: 600;

    text-decoration: none;

    transition: 0.2s;

  }



  .register-link a:hover {

    color: #1A7A35;

  }

`;

